<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import ReviewsRatingStars from "@apps/reviews/components_v2/ReviewsRatingStars/ReviewsRatingStars.svelte";
    import ReviewsTheme from "@apps/reviews/components/ReviewsTheme/ReviewsTheme.svelte";
    import ReviewsStorefrontValuesService from "@apps/reviews/services/ReviewsStorefrontValuesService";
    import Text from "@components_v2/Typography/Text.svelte";
    import { lastValueFrom } from "rxjs";
    import { onMount } from "svelte";

    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";
    import T from "@components/T.svelte";

    import ReviewsSummaryQuery from "./queries/ReviewsSummaryQuery";
    import ReviewsSummaryService from "./services/ReviewsSummaryService";

    export let reviewsStorefrontValuesService: ReviewsStorefrontValuesService;
    export let reviewsSummaryService: ReviewsSummaryService;
    export let reviewsSummaryQuery: ReviewsSummaryQuery;
    export let afterWidgetInject: () => void;

    const reviewsBranding$ =
        reviewsStorefrontValuesService.selectReviewsBrandingOptions();
    const reviewsCount$ = reviewsSummaryQuery.count$;
    const reviewsAvgRating$ = reviewsSummaryQuery.avgRate$;
    const status$ = reviewsSummaryQuery.status$;

    onMount(() => {
        lastValueFrom(reviewsSummaryService.getReviewsSummary());

        afterWidgetInject();
    });

    $: showSkeleton = $status$ === STATUS.INITIAL_LOADING;
</script>

{#if $reviewsBranding$}
    <ReviewsTheme branding={$reviewsBranding$}>
        <div class="gw-rv-trust-badge">
            <Text class="gw-rv-trust-badge__count" variant="heading-3xl">
                {#if showSkeleton}
                    <BaseSkeleton height="1em" width="100px" />
                {:else}
                    {$reviewsCount$}
                {/if}
            </Text>
            <Text
                class="gw-rv-trust-badge__verified-text"
                variant="body-lg"
                tone="tertiary"
            >
                <T
                    namespace="reviews.ReviewsTrustBadgeWidget"
                    translationKey="verified_reviews"
                />
            </Text>
            <div class="gw-rv-trust-badge__rating">
                {#if showSkeleton}
                    <BaseSkeleton height="20px" width="100px" />
                {:else if $reviewsAvgRating$}
                    <ReviewsRatingStars
                        rating={$reviewsAvgRating$}
                        starsSize={20}
                        showIconTitle={false}
                    />
                {/if}
            </div>
        </div>
    </ReviewsTheme>
{/if}

<style lang="postcss">
    @import "../../../../themes/default_v2/default.css";

    .gw-rv-trust-badge {
        width: calc(160px - (var(--gw-space-400) * 2));
        display: flex;
        flex-direction: column;
        gap: var(--gw-space-100);
        padding: var(--gw-space-400);
        text-align: center;
        border-radius: var(--gw-border-radius-200);
        background: var(--gw-bg-fill, #fff);

        :global(&__verified-text) {
            text-transform: uppercase;
        }
        &__rating {
            display: flex;
            justify-content: center;
        }
    }
</style>
